import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  activeConversation,
  addMessage,
  removeChat,
  updateMessageStatus
} from '../../../../store/action/internalChat';

import { FormatDate } from '../formatDatePTBR';
import { FormatTime } from '../formatTIME';
import ReacScrollabelFeed from 'react-scrollable-feed';
import { Button } from 'reactstrap';
import { RiAttachment2 } from 'react-icons/ri';
import UploadFileModal from '../modal';
import { FlexMediaPreviewerV2 } from '../flexMediaPreviewer v2';
import { MdClose, MdEmojiEmotions } from 'react-icons/md';
import AudioSender from '../audioSender/index';
import { FaMicrophone } from 'react-icons/fa';
import { BsCheck2, BsCheck2All } from 'react-icons/bs';
import { ObjectId } from 'bson';

import {
  Container,
  Header,
  BodyChat,
  BalloonRight,
  BalloonLeft,
  InputArea,
  ContentMessages,
  NotificationBadge,
  MessageStatusRight,
  MessageStatusLeft,
  EmojiMenu,
  EmojiGrid,
  EmojiButton,
  InputRow,
  EmojiToggle
} from './style';

import api from '../../config/configAPI';
import { useConectionSocketChatInternal } from 'hooks/useInternalChatSocket';
import { IoIosSend } from 'react-icons/io';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';

import { Emojis } from '../emojisList';

export const ChatIndice = forwardRef((props) => {
  const dispatch = useDispatch();
  const { data, unreadFromUsers = [], setUnreadFromUsers } = props;

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const { socketInternalChat } = useConectionSocketChatInternal();

  const [chatToggle, setChatToggle] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [isRecording, setIsRecording] = useState(false);

  const [messageIdFile, setMessageIdFile] = useState(null);

  function modifyAcive(boll) {
    dispatch(activeConversation(chatToggle, boll));
    if (boll) {
      updatedChatConversation();
      if (unreadFromUsers.includes(data.login)) {
        setUnreadFromUsers((prev) =>
          prev.filter((login) => login !== data.login)
        );
      }
    }
  }

  function closeChatSpecific(param) {
    dispatch(removeChat(param.login));
  }

  function updatedChatConversation() {
    socketInternalChat.emit('chat:opened', {
      self: localStorage.getItem('login'),
      partnerId: data.login,
      groupId: ''
    });
  }

  function updatedClosedChat() {
    socketInternalChat.emit('chat:closed', {
      conversationId: data.id
    });
  }

  const getStatusIcon = (message) => {
    const situation = message?.status?.situation;

    if (!situation) return null;

    switch (situation) {
      case 'sent':
        return <BsCheck2 size={16} color="#9e9e9e" />;
      case 'received':
        return <BsCheck2All size={16} color="#9e9e9e" />;
      case 'read':
        return <BsCheck2All size={16} color="#1d9bf0" />;
      default:
        return null;
    }
  };

  function getMessages(sender, received) {
    api
      .get(`/conversations/${sender}/${received}/messages`)
      .then((response) => {
        dispatch(addMessage(response.data.messages, data.id, sender, false));
      })
      .catch((err) => {
        console.log(
          'Erro ao adicionar mensagem:',
          err.response?.data?.mensagem || err.message
        );
      });
  }

  const enviarMensagem = (e) => {
    e.preventDefault();
    if (!mensagem.trim()) return;

    const mensagemId = new ObjectId().toHexString();
    const login = localStorage.getItem('login');
    const dataSendMessage = {
      to: data.login,
      from: login,
      content: mensagem,
      mensagemId: mensagemId
    };

    socketInternalChat.emit('message:send', dataSendMessage);
    dispatch(addMessage(mensagem, data.login, login, true, mensagemId));
    setMensagem('');
  };

  useEffect(() => {
    setChatToggle(data);
  }, [data]);

  useEffect(() => {
    const handleMessage = (dados) => {
      const isFile = !!dados.source;

      const mensagemFormatada = {
        content: '',
        sender: dados.sender,
        createdAt: new Date().toISOString(),
        id: dados.id,
        status: dados.status,
        ...(isFile && {
          type: 'file',
          source: dados.source,
          mensagemId: messageIdFile
        })
      };

      if (data.id == dados.conversationId) {
        dispatch(addMessage(mensagemFormatada, data.login, dados.sender, true));
      }

      if (dados.sender === data.login && chatToggle?.active) {
        if (unreadFromUsers.includes(data.login)) {
          setUnreadFromUsers((prev) =>
            prev.filter((login) => login !== data.login)
          );
        }
      }
    };

    socketInternalChat.off('message', handleMessage);
    socketInternalChat.on('message', handleMessage);

    return () => {
      socketInternalChat.off('message', handleMessage);
    };
  }, [data.login, chatToggle?.active, unreadFromUsers]);

  useEffect(() => {
    const handleStatusChange = (updatedMessage) => {
      if (
        updatedMessage.conversationId === data.id &&
        updatedMessage.sender === localStorage.getItem('login')
      ) {
        dispatch(
          updateMessageStatus(
            updatedMessage.conversationId,
            updatedMessage.id,
            updatedMessage.status,
            localStorage.getItem('login')
          )
        );
      }
    };

    socketInternalChat.off('change:statusMessage', handleStatusChange);
    socketInternalChat.on('change:statusMessage', handleStatusChange);

    return () => {
      socketInternalChat.off('change:statusMessage', handleStatusChange);
    };
  }, [data.id, data.login, socketInternalChat]);

  useEffect(() => {
    getMessages(localStorage.getItem('login'), data.login);
  }, [data.login]);

  const [isEmojiMenuOpen, setEmojiMenuOpen] = useState(false);

  const insertEmoji = (emoji) => {
    setMensagem((prev) => (prev || '') + emoji);
  };
  const inputRef = useRef(null);

  return (
    <Container>
      <Header
        color={systemConfiguration.primary_color}
        fontColor={systemConfiguration.internal_chat_font_color}
      >
        <button
          className="header"
          onClick={() => modifyAcive(!chatToggle.active)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            border: 'none',
            background: 'transparent',
            padding: 0,
            cursor: 'pointer'
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {data.name}
            {unreadFromUsers.includes(data.login) && <NotificationBadge />}
          </span>
        </button>
        <div className="actions-header-chat-internal">
          <MdClose
            size="21"
            color="white"
            type="button"
            onClick={() => {
              closeChatSpecific(data);
              updatedClosedChat();
            }}
          />
        </div>
      </Header>

      <BodyChat size={chatToggle.active}>
        <ReacScrollabelFeed forceScroll className="area-messages">
          {data?.messages?.map((message, index) => {
            const isSender = localStorage.getItem('login') === message.sender;

            return (
              <div key={index}>
                {new Date(data.messages[index]?.createdAt).getDate() !==
                  new Date(data.messages[index - 1]?.createdAt).getDate() && (
                  <FormatDate date={message.createdAt} />
                )}

                <ContentMessages align={isSender ? 'flex-end' : 'flex-start'}>
                  {isSender ? (
                    <BalloonRight
                      fontColor={systemConfiguration.internal_chat_font_color}
                      color={systemConfiguration.internal_chat_balloon_color}
                    >
                      {message.type === 'file' ? (
                        <>
                          <div className="content">
                            <FlexMediaPreviewerV2 fileURL={message.source} />
                          </div>
                          <MessageStatusRight>
                            <FormatTime
                              paramAlign="right"
                              date={message.createdAt}
                            />
                            {getStatusIcon(message)}
                          </MessageStatusRight>
                        </>
                      ) : (
                        <div className="content">
                          <span className="text">
                            {String(message.content ?? '')}
                          </span>

                          <MessageStatusRight>
                            <FormatTime
                              paramAlign="right"
                              date={message.createdAt}
                            />
                            {getStatusIcon(message)}
                          </MessageStatusRight>
                        </div>
                      )}
                    </BalloonRight>
                  ) : (
                    <BalloonLeft
                      fontColor={systemConfiguration.internal_chat_font_color}
                      color={systemConfiguration.internal_chat_balloon_color}
                    >
                      {message.type === 'file' ? (
                        <FlexMediaPreviewerV2 fileURL={message.source} />
                      ) : (
                        message.content
                      )}
                      <MessageStatusLeft>
                        <FormatTime
                          paramAlign="left"
                          date={message.createdAt}
                        />
                      </MessageStatusLeft>
                    </BalloonLeft>
                  )}
                </ContentMessages>
              </div>
            );
          })}
        </ReacScrollabelFeed>
      </BodyChat>

      <InputArea size={chatToggle.active} onSubmit={(e) => enviarMensagem(e)}>
        {!isRecording ? (
          <form
            onSubmit={enviarMensagem}
            className="form-chat-internal"
            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
          >
            <InputRow>
              <EmojiToggle
                type="button"
                onClick={() => setEmojiMenuOpen((v) => !v)}
                aria-haspopup="true"
                aria-expanded={isEmojiMenuOpen}
                title="Abrir menu de emojis"
              >
                <MdEmojiEmotions size={20} color="#676666ff" />
              </EmojiToggle>
              <input
                ref={inputRef}
                type="text"
                name="mensagem"
                value={mensagem}
                autoComplete="off"
                onChange={(e) => setMensagem(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    enviarMensagem(e);
                  }
                }}
                className="input-chat-internal-write"
                placeholder="Digite uma mensagem"
              />

              {isEmojiMenuOpen && (
                <EmojiMenu role="menu" aria-label="Menu">
                  <EmojiGrid>
                    {Emojis.map((e) => (
                      <EmojiButton
                        key={e}
                        type="button"
                        onClick={() => {
                          insertEmoji(e);
                          setEmojiMenuOpen(false);
                          requestAnimationFrame(() => {
                            const inputField = inputRef.current;
                            if (!inputField) return;
                            inputField.focus();
                            const cursorPosition = inputField.value.length;
                            inputField.setSelectionRange(
                              cursorPosition,
                              cursorPosition
                            );
                          });
                        }}
                        title={e}
                      >
                        {e}
                      </EmojiButton>
                    ))}
                  </EmojiGrid>
                </EmojiMenu>
              )}
            </InputRow>

            <div className="chat-buttons">
              {mensagem && mensagem.length > 0 ? (
                <Button
                  type="submit"
                  className="shadow-none"
                  style={buttonStyle(systemConfiguration.primary_color)}
                  size="sm"
                  title="Enviar mensagem"
                >
                  <IoIosSend
                    size={18}
                    color="#ffffff"
                    onClick={(e) => {
                      e.preventDefault();
                      enviarMensagem(e);
                    }}
                  />
                </Button>
              ) : (
                <>
                  <Button
                    type="button"
                    className="shadow-none"
                    color="link"
                    size="sm"
                    title="Gravar áudio"
                    onClick={() => setIsRecording(true)}
                  >
                    <FaMicrophone size={20} color="#676666ff" />
                  </Button>

                  <Button
                    type="button"
                    className="shadow-none"
                    color="grey"
                    size="sm"
                    title="Enviar arquivo"
                    onClick={() => setShowUploadModal(true)}
                  >
                    <RiAttachment2 size={22} />
                  </Button>
                </>
              )}
            </div>
          </form>
        ) : (
          <AudioSender
            conversationId={data.id}
            destination={data.login}
            sender={localStorage.getItem('login')}
            setIsRecording={setIsRecording}
            isRecording={isRecording}
            setMessageIdFile={setMessageIdFile}
          />
        )}
      </InputArea>

      <UploadFileModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        setMessageIdFile={setMessageIdFile}
        conversationId={data.id}
        sender={localStorage.getItem('login')}
        destination={data.login}
      />
    </Container>
  );
});

ChatIndice.displayName = 'ChatIndice';
